import { Container, Row, Col, Button, Image } from 'react-bootstrap';
import TutorImg from 'assets/img/landing/totur.png';
import StudImg from 'assets/img/landing/bookDemoStud.svg';
import { Props } from './bookDemo.type';
import BeatMonoLogo from 'assets/img/landing/monoLogo.svg';
import { ReactNode, useState } from 'react';
import { LandingRole } from 'pages/landing/main.type';
import BookDemoModal from 'components/modals/BookDemoModal';

const StudentDemo = () => {
  const [show, setShow] = useState(false);
  return (
    <Container fluid className="studDemo_wrapper_card">
      <BookDemoModal show={show} onClose={() => setShow(false)} />
      <Image
        src={StudImg}
        alt="studwrapper"
        className="w-100 scaleX--1 position-lg-relative d-none d-lg-block"
      />
      <Row className="position-lg-absolute bottom-0 w-lg-100 d-lg-flex d-block justify-content-end">
        <Col lg={6} className="glassmophism-1 me-3 p-lg-14 p-4 rounded-4">
          <Image src={BeatMonoLogo} alt="MonoLogo" height={60} width={60} />
          <p className="text-white pt-2">
            Join countless institutions and employers who rely on our platform
            for seamless hiring processes and effective student training.
          </p>
          <Button
            variant="primary"
            className="px-6 py-3 rounded-4 mt-4"
            onClick={() => setShow(true)}
          >
            Book Demo
          </Button>
        </Col>
      </Row>
      <div className="w-100 justify-content-center position-absolute bottom-0 studDemo_wrapper_card_clippath ps-3 d-none d-lg-flex">
        <div className="studDemo_wrapper_card_clippath_box box2 rounded-top-4 bg-body-highlight"></div>
      </div>
    </Container>
  );
};
const RecruiterDemo = () => {
  const [show, setShow] = useState(false);
  return (
    <Container fluid className="bg-body book-demo">
      <BookDemoModal show={show} onClose={() => setShow(false)} />
      <Row>
        <Col lg={5} className="d-flex justify-content-start p-0">
          <Image src={TutorImg} className="w-75 h-100" />
        </Col>
        <Col
          lg={7}
          className="d-flex flex-column justify-content-center align-items-center pb-8"
        >
          <p className="fs-3 fw-bolder">Why Book a Demo?</p>
          <p className="text-center">
            Experience AI-driven talent matching, pre-assessed candidates, and
            streamlined hiring with CRUD Beat's demo.
          </p>
          <Button
            variant="primary"
            className="px-6 py-3 rounded-4 mt-4"
            onClick={() => setShow(true)}
          >
            Get Free Trail
          </Button>
        </Col>
      </Row>
    </Container>
  );
};
const CollegeDemo = () => {
  const [show, setShow] = useState(false);
  return (
    <Container fluid className="bg-body book-demo clgDemo">
      <BookDemoModal show={show} onClose={() => setShow(false)} />
      <Row>
        <Col
          lg={12}
          className="d-flex flex-column justify-content-center align-items-center py-8"
        >
          <p className="fs-4 fw-bolder text-white">
            Book a Free Demo with CRUDBeat Today!
          </p>
          <p className="text-center text-white">
            Discover how CRUDBeat can transform your college’s recruitment
            process with seamless tech <br />
            assessments, skill development programs, and global job
            opportunities. See the platform in action <br /> and explore how we
            can empower your students for career success.
          </p>
          <Button
            variant="primary"
            className="px-6 py-3 rounded-4 mt-4"
            onClick={() => setShow(true)}
          >
            Book Demo
          </Button>
        </Col>
      </Row>
    </Container>
  );
};
const demoDetails: Record<LandingRole, ReactNode | null> = {
  student: <StudentDemo />,
  recruiter: <RecruiterDemo />,
  college: <CollegeDemo />,
  default: null
};
const WhyBookDemo = ({ role }: Props) => {
  const DemoElement = demoDetails[role];
  return (
    <Container fluid className="bg-body-highlight studDemo">
      <Row className="px-4 pt-10 pb-4 studDemo_wrapper">{DemoElement}</Row>
    </Container>
  );
};

export default WhyBookDemo;
